/* eslint-disable @typescript-eslint/no-explicit-any */
import { filterClasses } from "@/utils/filter-styles";

export const MultiValueTag = (props: any) => {
  const { data, removeProps, selectProps } = props;
  const values = selectProps.value || [];
  const index = values.findIndex((v: any) => v.value === data.value);
  
  if (index < 2) {
    const truncatedLabel = data.label.length > 12 
      ? `${data.label.substring(0, 12)}...` 
      : data.label;
    
    return (
      <div 
        title={data.label}
        className={filterClasses.multiValueTag}
      >
        <span className={filterClasses.multiValueText}>
          {truncatedLabel}
        </span>
        <span 
          className={filterClasses.multiValueRemove}
          onClick={removeProps?.onClick}
        >
          ×
        </span>
      </div>
    );
  }
  
  if (index === 2) {
    const remaining = values.length - 2;
    const remainingNames = values.slice(2).map((v: any) => v.label).join(', ');
    
    return (
      <div 
        title={`Mais ${remaining}: ${remainingNames}`}
        className={filterClasses.moreItemsTag}
      >
        +{remaining}
      </div>
    );
  }
  
  return null;
};
